module.exports = __webpack_public_path__ + "img/stock2.25671f4d.png";